// GENERATE BY icons/script/react-scripts.mjs
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { SVGProps } from 'react';
const File05 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m19.1213 7.1214-4.2426-4.2427A2.9986 2.9986 0 0 0 14 2.2696v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305a2.9992 2.9992 0 0 0-.6092-.8787Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 2.2695v4.1306c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C14.7599 8 15.0399 8 15.6 8h4.1305M14 17H8m8-4H8m12-3.0118V17.2c0 1.6802 0 2.5202-.327 3.162a2.9994 2.9994 0 0 1-1.311 1.311C17.7202 22 16.8802 22 15.2 22H8.8c-1.6802 0-2.5202 0-3.162-.327a2.9997 2.9997 0 0 1-1.311-1.311C4 19.7202 4 18.8802 4 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 2 7.1198 2 8.8 2h3.2118c.7337 0 1.1006 0 1.4459.0829.3061.0735.5987.1947.8672.3592.3027.1855.5621.445 1.081.9638l3.1882 3.1882c.5189.5189.7783.7783.9638 1.081.1645.2685.2857.5611.3592.8672C20 8.8876 20 9.2545 20 9.9883Z"
    />
  </svg>
);
export default File05;
